// extracted by mini-css-extract-plugin
export default {"options-bar":"OptionBar_options-bar__qvH-E","optionOpenClose":"OptionBar_optionOpenClose__ejooq","opened":"OptionBar_opened__G+aC0","major-options":"OptionBar_major-options__wZ4Rs"};